import { useLanguage } from '../../context/LanguageContext';

const StepIndicator = ({ currentStep, totalSteps }) => {
  const { lang } = useLanguage();
  const progress = (currentStep / totalSteps) * 100;

  return (
    <div className="mb-10" data-testid="step-indicator">
      <p className="text-sm text-[#A0AEC0] mb-3">
        {lang === 'de' ? `Schritt ${currentStep} von ${totalSteps}` : `Step ${currentStep} of ${totalSteps}`}
      </p>
      <div className="h-1 w-full bg-[#1A2B42]">
        <div 
          className="h-full bg-[#00D9C8] transition-all duration-300"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};

export default StepIndicator;
